import moment from 'moment-timezone'
import { apiPaths } from '../../config'
import { factorySetStateAction } from '../factory'
import { http } from '../../services/index'
// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'profile/SET_STATE',
  GET_MEMBER_DETAIL: 'profile/GET_MEMBER_DETAIL',
  GET_WEEKLY_REPORT_DATA: 'profile/GET_WEEKLY_REPORT_DATA',
  GET_NIGHT_BY_NIGHT_DATA: 'profile/GET_NIGHT_BY_NIGHT_DATA',
  GET_MEMBER_BODY_CLOCK: 'profile/GET_MEMBER_BODY_CLOCK',
  GET_MEMBER_TRENDS: 'profile/GET_MEMBER_TRENDS',
  STORE_HISTORY_NOTES: 'profile/STORE_HISTORY_NOTES',
  GET_HISTORY_NOTES: 'profile/GET_HISTORY_NOTES',
  GET_MEMBER_DIARY: 'profile/GET_MEMBER_DIARY',
  UPDATE_HISTORY_NOTE: 'profile/UPDATE_HISTORY_NOTE',
  GET_DAILY_REPORT_DATA: 'profile/GET_DAILY_REPORT_DATA',
  GET_MEMBER_AVG_SLEEP_METRICS: 'profile/GET_MEMBER_AVG_SLEEP_METRICS',
  GENERATE_CLINIC_REPORT: 'profile/GENERATE_CLINIC_REPORT',
  GENERATE_CLINIC_PATIENT_REPORT: 'profile/GENERATE_CLINIC_PATIENT_REPORT',
  GENERATE_CLINIC_WEEKLY_REPORT: 'profile/GENERATE_CLINIC_WEEKLY_REPORT',
  SOCKET_HANDLER: 'profile/SOCKET_HANDLER',
  GET_LIVE_DEVICE_DATA: 'profile/GET_LIVE_DEVICE_DATA',
  GET_BOX_PLOT_DATA_HISTORY: 'profile/GET_BOX_PLOT_DATA_HISTORY',
  GET_CURRENT_DEVICE: 'profile/GET_CURRENT_DEVICE',
  UPDATE_THRESHOLD: 'profile/UPDATE_THRESHOLD',
  GET_DEVICE_RAW_RR: 'profile/GET_DEVICE_RAW_RR',
  GET_RESIDENT_STATUS_NOTES: 'profile/GET_RESIDENT_STATUS_NOTES',
  GET_PATIENT_RR_24_72_HRs: 'profile/GET_PATIENT_RR_24_72_HRs',
}

function getMyInIt(userUID) {
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    queryStringParameters: {
      // OPTIONAL
      user_uid: userUID,
    },
  }
  return myInit
}
function getMyInItPost(userUID) {
  const myInit = {
    // OPTIONAL
    body: { user_uid: userUID },
    headers: {}, // OPTIONAL
  }
  return myInit
}
/* function bodyClockInit(Obj) {
  const myInit = {
    headers: {},
    queryStringParameters: {
      user_id: Obj.userUID,
      graph: Obj.graph,
    },
  }
  return myInit
} */
function SleepStagesHistory(userUID, date) {
  const myInit = {
    // OPTIONAL
    queryStringParameters: {
      user_uid: userUID,
      date_of_sleep: date,
    },
    headers: {}, // OPTIONAL
  }
  return myInit
}

export const profileSetState = factorySetStateAction(actions.SET_STATE)

// export const getMemberDetail = (userUID) =>
//   http
//     .get(apiPaths.All.apiMemberDetail, getMyInIt(userUID))
//     .then((res) => res)
//     .catch((err) => {
//       window.log('memberDetail', err)
//       return []
//     })

export const getPatientDailyReport = (payload) => ({
  type: actions.GET_PATIENT_RR_24_72_HRs,
  payload,
})

export const getMemberSleepSessions = (userUID) =>
  http
    .get(apiPaths.All.apiMemberSleepSessions, getMyInIt(userUID))
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      window.log('memberSleepSessions', !response ? err : response)
      return []
    })

export const getMemberCSIHistory = (userUID) =>
  http
    .post(apiPaths.All.apiMemberCSIHistory, getMyInItPost(userUID))
    .then((res) => res)
    .catch((err) => {
      window.log('memberCSIHistory', err)
      return []
    })

// export const getLastSleepStagesHistory = (userUID) =>
//   http
//     .get(apiPaths.All.apiMemberSleepStages, { user_uid: userUID }, {})
//     .then((res) => res)
//     .catch((err) => {
//       const { response } = err
//       window.log('error getLastSleepStagesHistory', !response ? err : response)
//       return { status: 404 }
//     })

export const getMemberSleepStagesHistory = (userUID, date) =>
  http
    .get(apiPaths.All.apiMemberSleepStages, SleepStagesHistory(userUID, date))
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      window.log('error getMemberSleepStagesHistory', !response ? err : response)
      return { status: 404 }
    })

export const getMemberBodyClock = (dataObj) =>
  http
    .get(
      apiPaths.All.apiCircadiaAnalysisGraphs,
      {
        user_id: dataObj.userUID,
        graph: dataObj.graph,
      },
      {},
    )
    .then((res) => {
      const { img } = res
      const { graph } = dataObj

      if (graph === 'process_c') {
        return res
      }
      if (img) {
        return img
      }

      return res
    })
    .catch((err) => {
      window.log('bodyclocktimeline', err)
      return {}
    })

export const getMemberPRCImage = (dataObj) =>
  http
    .get(
      apiPaths.All.apiCircadiaAnalysisGraphs,
      {
        user_id: dataObj.userUID,
        graph: dataObj.graph,
      },
      {},
    )
    .then((res) => res || '')
    .catch((err) => {
      window.log('PRC error', err)
      return ''
    })

export const getMemberBodyClockImage = (dataObj) =>
  http
    .get(
      apiPaths.All.apiCircadiaAnalysisGraphs,
      { user_id: dataObj.userUID, graph: dataObj.graph },
      {},
    )
    .then((res) => res || '')
    .catch((err) => {
      window.log('bodyclock display error', err)
      return ''
    })

export const getMemberProcessCImage = (dataObj) =>
  http
    .get(
      `${apiPaths.All.apiCircadiaAnalysisGraphs}?user_id=${dataObj.userUID}&graph=${dataObj.graph}`,
    )
    .then((res) => res || '')
    .catch((err) => {
      window.log('process c error', err)
      return ''
    })

export const getMetricsHistory = (userUID) =>
  http
    .post(
      apiPaths.All.apiMetricsHistory,
      { user_uid: userUID, date: moment().format('YYYY-MM-DD') },
      {},
    )
    .then((res) => res)
    .catch((err) => {
      window.log('memberSleepSessions', err)
      return []
    })

export const getPatientsMetrics = (dataObj) =>
  http
    .post(apiPaths.Clinic.apiPatientsMetrics, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      window.log('patients metrics error: ', err)
      return []
    })

export const storeHistory = (dataObj) =>
  http
    .post(apiPaths.Clinic.apiClinicNotesCreate, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      window.log('store historyNotes error: ', err)
      return []
    })

export const UpdateHistory = (dataObj) =>
  http
    .post(apiPaths.Clinic.apiClinicNotesUpdate, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      window.log('update historyNote error: ', err)
      return []
    })

export const historyNotes = (dataObj) =>
  http
    .get(apiPaths.Clinic.apiClinicNotesList, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      window.log('list historyNotes error: ', err)
      return []
    })

export const getMemberDiary = (dataObj) =>
  http
    .get(apiPaths.All.apiMemberDiary, { member_id: dataObj.userUID, date: dataObj.date }, {})
    .then((res) => res)
    .catch((err) => {
      window.log('memberDiary error: ', err)
      return []
    })

export const getMemberAVGSleepMetrics = (memberID) =>
  http
    .get(apiPaths.All.apiAVGSLeepMetrics, { member_id: memberID }, {})
    .then((res) => res)
    .catch((err) => {
      window.log('AVG sleep metrcis error: ', err)
      return []
    })

export const getBreathingPatternData = (data) =>
  http
    .get(apiPaths.All.apiBreathingPattern, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('Breathing Pattern error: ', err)
      return []
    })

export const getDeviceLastTwoHourData = (data) =>
  http
    .get(apiPaths.Clinic.apiPatientMinutelyAvgReport, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('minutelyAvgReport error: ', err)
      return []
    })

export const getDeviceLastRRData = (data) =>
  http
    .get(apiPaths.Clinic.apiPatientLastResp, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('minutelyAvgReport error: ', err)
      return []
    })
export const getBoxPlotData = (data) =>
  http
    .get(apiPaths.Clinic.apiBoxPlotData, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('boxPlotData error: ', err)
      return []
    })

export const getPatientBoxPlotData = (data) =>
  http
    .get(apiPaths.Clinic.apiPatientTiBHistoryCombined, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('boxPlotData error: ', err)
      return []
    })

export const getPatientTiBData = (data) =>
  http
    .get(apiPaths.Clinic.apiPatientTiBHistoryData, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('boxPlotData error: ', err)
      return []
    })

export const getDeviceRawRR = (data) =>
  http
    .get(apiPaths.Clinic.apiPatientRawData, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('deviceRawRR error: ', err)
      return []
    })

export const getAllStoredNotesOfPatient = (data) =>
  http
    .get(`${apiPaths.Clinic.apiGetAllStoredNotesOfPatient}/${data.patient_id}`, {}, {})
    .then((res) => res)
    .catch((err) => {
      window.log('resident change statuses error: ', err)
      return []
    })

export const convertTime = (date, timezone, format = 'MM/DD/YYYY HH:mm:ss') => {
  const m = moment.utc(date) // parse input as UTC
  if (!timezone) {
    const local = m.local().format(format)
    return local
  }
  const newDate = m.tz(timezone).format(format)
  return newDate
}

export const convertTimeOffset = (date, offset, format = 'MM/DD/YYYY HH:mm:ss') => {
  const m = moment.utc(date)
  if (offset === undefined || offset === null) {
    const local = m.local().format(format)
    return local
  }
  const newDate = m.utcOffset(offset)
  return newDate.format(format)
}

export const getOffsetFromRecommendation = (recommendation) => {
  recommendation = recommendation.split('\n')
  recommendation = recommendation[1] ? recommendation[1] : ''
  recommendation = recommendation.split(' ')
  recommendation = recommendation[2] ? parseFloat(recommendation[2], 10) : 0

  return recommendation
}

export default actions
